import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import api, { formatApiError } from "../lib/api";
import { Logo } from "../components/Logo";
import NoIndex from "../components/NoIndex";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!token) {
      toast.error("Reset link is missing a token");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password reset! Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <NoIndex />
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center">
          <Logo className="h-8" />
        </div>
        <h1 className="font-heading text-2xl font-bold tracking-tight">Set a new password</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <Input
            type="password"
            required
            minLength={8}
            placeholder="New password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="reset-password-input"
          />
          <p className="text-xs text-muted-foreground" data-testid="password-policy-hint">
            At least 8 characters, including a letter and a number.
          </p>
          <Button type="submit" disabled={loading} className="w-full" data-testid="reset-password-submit-btn">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Reset Password"}
          </Button>
        </form>
        <p className="mt-6 text-center text-sm text-muted-foreground">
          <Link to="/login" className="font-medium text-primary hover:underline">
            Back to login
          </Link>
        </p>
      </div>
    </div>
  );
}
